export default "/assets/website/components/images/printer.e2ddaa82.svg";